module.exports = __webpack_public_path__ + "static/maps-section-cloud-2-fc95d89bd34b9ddfdaa54dd0fed624b8.png";